import React from 'react';
import PropTypes from 'prop-types';

import PinterestBoardForm from 'js/components/pinterest_board_form';

export default function CreateBoard({handleCreateBoard, handleCancelBoard}) {
    return (
        <PinterestBoardForm
            onCreate={handleCreateBoard}
            onCancel={handleCancelBoard}
        />
    );
}

CreateBoard.propTypes = {
    handleCreateBoard: PropTypes.func.isRequired,
    handleCancelBoard: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/ad_mode_info/components/views/create_board.js